import { Head, usePage } from "@inertiajs/react";
import { ClipboardList, Trash2 } from "lucide-react";
import { useState } from "react";
import { AuditDrawer } from "@/components/admin-portal/chat/audit-drawer";
import { ChatInput } from "@/components/admin-portal/chat/chat-input";
import { ChatWindow } from "@/components/admin-portal/chat/chat-window";
import { PageContainer } from "@/components/admin-portal/shared/page-layout";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useChat } from "@/hooks/use-chat";
import type { GlobalPageProps } from "@/types/globals";

export default function Index() {
	const { props: globalProps } = usePage<GlobalPageProps>();
	const searchUrl = globalProps.adminPortal.router.adminPortal.chat.search;
	const auditUrl = globalProps.adminPortal.router.adminPortal.chat.audit;

	const { messages, isLoading, sendMessage, clearMessages } =
		useChat(searchUrl);

	const [auditOpen, setAuditOpen] = useState(false);

	const lastResult = [...messages]
		.reverse()
		.find((m) => m.role === "bot" && m.therapists && m.searchContext);

	return (
		<>
			<Head title="AI Chat" />
			<PageContainer className="min-h-[calc(100vh-8rem)] flex flex-col">
				<div className="flex items-center justify-between">
					<div>
						<h1 className="text-lg font-bold tracking-tight uppercase">
							AI Therapist Search
						</h1>
						<p className="text-sm text-muted-foreground">
							Chat naturally to find available therapists
						</p>
					</div>
					<div className="flex items-center gap-2">
						{lastResult && (
							<Button
								variant="outline"
								size="sm"
								onClick={() => setAuditOpen(true)}
								disabled={isLoading}
							>
								<ClipboardList className="size-4 mr-1" />
								Audit
							</Button>
						)}
						{messages.length > 0 && (
							<Button
								variant="ghost"
								size="sm"
								onClick={clearMessages}
								disabled={isLoading}
							>
								<Trash2 className="size-4 mr-1" />
								Clear
							</Button>
						)}
					</div>
				</div>
				<Separator className="my-4" />

				<div className="flex flex-1 flex-col overflow-hidden rounded-lg border">
					<ChatWindow messages={messages} isLoading={isLoading} />
					<ChatInput onSend={sendMessage} isLoading={isLoading} />
				</div>
			</PageContainer>

			<AuditDrawer
				open={auditOpen}
				onOpenChange={setAuditOpen}
				searchContext={lastResult?.searchContext ?? null}
				auditUrl={auditUrl}
			/>
		</>
	);
}
